import React, { ReactNode } from 'react';
import Modal from '@mui/material/Modal';
import { Backdrop, Fade, Paper } from '@mui/material';
import { useThemeStore } from '../../stores/ThemeStore';

interface IModalProps {
  open: boolean;
  handleClose?: () => void;
  children?: ReactNode;
  positioned?: boolean;
}

const ModalContainer: React.FC<IModalProps> = ({ open, handleClose, children, positioned = false }) => {

  const ContainerComponent = positioned ? Paper : 'div';

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open} timeout={500} unmountOnExit>
          <ContainerComponent
            sx={positioned ? {
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              borderRadius: 4,
              overflow: "hidden",
              width: 950,
              maxWidth: "100vw" 
            } : {}}
          >
            {children}
          </ContainerComponent>
        </Fade>
      </Modal>
    </div>
  );
}

export default ModalContainer;
